import FAQSectionI18n from "@/components/landing/shared/FAQSectionI18n";

const FAQOmnichannelSection = () => {
  return <FAQSectionI18n translationPrefix="inboxPage" itemClass="bg-secondary/50 rounded-xl border border-border px-6" />;
};

export default FAQOmnichannelSection;
